<div class="pricing__page">
  <div class="row">
    <div class="col-md-1" *ngIf="false">
      <button id="pricing-back-button" type="button" class="button ghost__button icon__left p-0 mt-3"
              (click)="goBack()">
        <em class="fa fa-arrow-left"></em>
        Back
      </button>
    </div>
    <div class="col-md-12">
      <div class="title">
        <!--Find the <span class="color&#45;&#45;blue">best pricing plan <span class="color&#45;&#45;blue">for you.</span>-->
        Find the <span class="color--blue">Right Valuation Solution</span> for Your Needs.
      </div>
    </div>
  </div>

  <div class="row justify-content-md-center text-center" *ngIf="false">
    <div class="col-md-2 pill__structure">
      <button class="button pill__button" [ngClass]="{'secondary__button': !isMonthly, 'primary__button': isMonthly}"
              (click)="isMonthly = true;">Monthly
      </button>
      <button class="button pill__button" [ngClass]="{'secondary__button': isMonthly, 'primary__button': !isMonthly}"
              (click)="isMonthly = false;">Yearly
      </button>
    </div>
  </div>

  <div class="row plan__row justify-content-md-center">

    <div class="col-md-9">

      <div class="row">

        <div class="col-md-3 plan__card bg__gray">
          <div class="badge mb-3 badge__blue">no payment needed</div>
          <h4>SBA Lenders</h4>
          <h6 class="color--blue">Free</h6>
          <div class="plan__details">
            A free internal business valuation software solution for SBA lenders.
          </div>

          <div class="small__table__data pt-0">
            <!-- <div class="title">Everything in Professional, plus</div> -->
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Ideal for Conducting internal business valuations prior to financing decisions</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Basic valuation Estimate</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Downloadable Summary Report</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Detailed PDF Report</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Editable Reports</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Import Financial Data</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Report Sharing</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Controlled Report Access</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Version History and Comparisons</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Discounted Additional Reports</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Financing-Specific Valuation Tools</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Team Collaboration</span>
            </div>
            <!-- <div class="bottom__title">
              <strong>* 20 reports per year</strong>&nbsp;is not included in this plan
            </div> -->
          </div>
        </div>

        <div class="col-md-3 plan__card bg__gray">
          <div class="badge mb-3 badge__gray green__badge">One Time Report</div>
          <h4>Business Brokers</h4>
          <h6 class="color--blue">$249 per report</h6>
          <div class="plan__details">
            Good for brokers who want to advise their business owner clients
          </div>

          <div class="small__table__data pt-0">
            <!-- <div class="title">Everything in One Time, plus</div> -->
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Ideal for Evaluating potential deals and setting realistic expectations</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Basic valuation Estimate</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Downloadable Summary Report</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Detailed PDF Report</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Editable Reports</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Import Financial Data</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Report Sharing</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Controlled Report Access</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Version History and Comparisons</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Discounted Additional Reports</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Deal Assessment Tools</span>
            </div>
          </div>
        </div>

        <div class="col-md-3 plan__card bg__gray">
          <div class="badge mb-3 badge__gray green__badge">One Time Report</div>
          <h4>Business Owner</h4>
          <h6 class="color--blue">$249 per report</h6>
          <div class="plan__details">
            Good for business owners who own 1 or 2 businesses
          </div>

          <div class="small__table__data pt-0">
            <!-- <div class="title">Everything in Basic, plus</div> -->
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Ideal for Determining business value for strategic planning or potential exit</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Basic valuation Estimate</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Downloadable Summary Report</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Detailed PDF Report</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Editable Reports</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Import Financial Data</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Report Sharing</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Controlled Report Access</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Version History and Comparisons</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Discounted Additional Reports</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Exit Planning Tools</span>
            </div>
          </div>
        </div>

        <div class="col-md-3 plan__card bg__gray">
          <div class="badge mb-3 badge__blue">no payment needed</div>
          <h4>Value Calculator</h4>
          <h6 class="color--blue">Free</h6>
          <div class="plan__details">
            Start off with a free approximate value and a 4-page report with the Value Calculator
          </div>

          <div class="small__table__data pt-0">
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Ideal for Satisfying curiosity without a comprehensive report</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>Basic valuation Estimate</span>
            </div>
            <div class="row__item">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
              <span>One-Time Report Access</span>
            </div>
          </div>
        </div>

        <!--<div class="col-md-3 plan__card bg__gray">
          <div class="badge mb-3 badge__gray green__badge">Good for business owners</div>
          <h4>One time</h4>
          <h6 class="color&#45;&#45;blue">$ {{constPricing.PRICE_PER_REPORT}} per report</h6>
          <div class="plan__details">
            Good for business owners who own 1 or 2 businesses
          </div>
        </div>

        <div class="col-md-3 plan__card bg__gray">
          <div class="badge mb-3 badge__gray green__badge">Most popular</div>
          <h4>Professional</h4>
          <h6 class="color&#45;&#45;blue">$ {{constPricing.PRICE_PER_YEAR}} per year</h6>
          <div class="plan__details">
            Up to 20 reports per month
          </div>
          <div class="plan__button">
            <button id="pricing-page-contact-us" type="button" class="button success__button w-100" *ngIf="false">
              Your current plan
            </button>
            <button id="pricing-page-contact-us" type="button" class="button secondary__button w-100" (click)="gotoCheckout()">
              Buy now
            </button>
        </div>
        </div>

        <div class="col-md-3 plan__card bg__gray">
          <div class="badge mb-3 badge__gray green__badge">Special price</div>
          <h4>Enterprise</h4>
          <h6 class="color&#45;&#45;blue">Special offer</h6>
          <div class="plan__details">
            Tell us about your requirements and we will find the best offer for you
          </div>
          <div class="plan__button">
              <button id="pricing-page-contact-us" type="button" class="button secondary__button w-100">
                Buy now
              </button>
          </div>
        </div>-->

      </div>

      <!-- For Web view -->
      <div class="small__table">
        <div class="row">
          <div class="col-md-12 text-center my-5">
            <h4>Discover pricing plans and features</h4>
          </div>
        </div>

        <div class="pricing__table">
          <div class="row sticky__header">
            <div class="col-md-4">
              <div class="font-weight-bold">Feature</div>
            </div>
            <div class="col-md-2">
              <div>SBA Lenders</div>
              <span>Free</span>
            </div>
            <div class="col-md-2">
              <div>Business Brokers</div>
              <span>${{constPricing.PRICE_PER_REPORT}} per report</span>
            </div>
            <div class="col-md-2">
              <div>Business Owner</div>
              <span>${{constPricing.PRICE_PER_REPORT}} per report</span>
            </div>
            <div class="col-md-2">
              <div>Value Calculator</div>
              <span>Free</span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              Ideal for
            </div>
            <div class="col-md-2 ideal-for">
              Conducting internal business valuations prior to financing decisions
            </div>
            <div class="col-md-2 ideal-for">
              Evaluating potential deals and setting realistic expectations
            </div>
            <div class="col-md-2 ideal-for">
              Determining business value for strategic planning or potential exit
            </div>
            <div class="col-md-2 ideal-for">
              Satisfying curiosity without a comprehensive report
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              Basic valuation Estimate
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              Downloadable Summary Report
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              Detailed PDF Report
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">

            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              Editable Reports
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">

            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              Import Financial Data
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">

            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              Report Sharing
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2"></div>
          </div>
          <!--<div class="row">
            <div class="col-md-4">
              White label PDF report
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-2"></div>
            <div class="col-md-2"></div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
          </div>-->
          <div class="row">
            <div class="col-md-4">
              Controlled Report Access
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2"></div>
          </div>
          <div class="row">
            <div class="col-md-4">
              Version History and Comparisons
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2"></div>
          </div>
          <div class="row">
            <div class="col-md-4">
              Discounted Additional Reports
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2"></div>
          </div>
          <div class="row">
            <div class="col-md-4">
              Financing-Specific Valuation Tools
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-2"></div>
            <div class="col-md-2"></div>
          </div>
          <div class="row">
            <div class="col-md-4">
              Team Collaboration
            </div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-2"></div>
            <div class="col-md-2"></div>
          </div>
          <div class="row">
            <div class="col-md-4">
              Deal Assessment Tools
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-2"></div>
          </div>
          <div class="row">
            <div class="col-md-4">
              Exit Planning Tools
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-2"></div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
            <div class="col-md-2"></div>
          </div>
          <div class="row">
            <div class="col-md-4">
              One-Time Report Access
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-2"></div>
            <div class="col-md-2"></div>
            <div class="col-md-2">
              <svg-icon name="blue-right-tick" svgClass="tick__svg"></svg-icon>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>
